import styled from 'styled-components';

import { ThemeProp } from '../../../../../theme/Themes';
import { Button, SecondaryButton } from './../../../../../components';

const commonNoteButtonProps = (props: ThemeProp) => {
  return `
      font-size: ${props.theme.fontSize.s};
      line-height: ${props.theme.lineHeight.s};
      font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
      width: 8.75rem;
      align-self: flex-end;
    `;
};

export const ShareButton = styled(Button)`
  ${(props: ThemeProp) => commonNoteButtonProps(props)}
  width: 5.625rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    flex: 1;
    height: 3rem;
  }
`;

export const CancelButton = styled(SecondaryButton)`
  ${(props: ThemeProp) => commonNoteButtonProps(props)}
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c200};
  width: 5.625rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    flex: 1;
    height: 3rem;
  }
`;

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;

  border-top: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 1rem 1.5rem 1.5rem 1.5rem;
    gap: 1rem;
    border-top: none;
  }
`;
